var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysRoom = function SvgSysRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.248 18.747v-2.332h-18.5v2.332a.5.5 0 0 1-1 0v-13.5a.5.5 0 0 1 1 0v6.828h8.835V8.212a1.532 1.532 0 0 1 1.392-1.64H14h-.005 3.879A3.964 3.964 0 0 1 21 8.207a6.149 6.149 0 0 1 1.241 3.795v.068h.007v6.668a.5.5 0 0 1-1 0v.008Zm0-3.334v-2.332h-8.72a.722.722 0 0 1-.091-.006H2.751v2.338h18.497Zm-.016-3.334a.202.202 0 0 0 .011-.068c0-2.445-1.511-4.43-3.365-4.43h-4.934c-.176.027-.358.29-.358.635v3.795c0 .023.004.046.011.068h8.635ZM5.5 8a2.5 2.5 0 1 1 4.998 0A2.5 2.5 0 0 1 5.5 8Zm1 0a1.502 1.502 0 0 0 .926 1.387A1.5 1.5 0 0 0 9.06 9.06 1.499 1.499 0 1 0 6.5 7.999Z"
  })));
};
export default SvgSysRoom;